import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_get_shippingcontainer_by_shippingContainerCodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shippingContainerCode: string }): 
  Promise<{ result: { Id?: number, TasksForExpectedTargetShippingContainer?: { Id?: number, OperationCodeId?: number, StatusId?: number }[] } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerCode)) {
      missingRequiredInParams.push('\'shippingContainerCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_get_shippingcontainer_by_shippingContainerCode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shippingContainerCode: string    }) {
        if(isNil(inParams.shippingContainerCode)) {
          return true; 
        }
      return false;
    }
}
